import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'Marker',
  props: {
    color: null
  },
  setup(__props) {
    const props = __props;
    const colorMap = generateColorMap({
      bg: 50,
      text: 700
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["rounded inline-flex items-center justify-center border-1", {
          [_unref(colorMap)[__props.color]]: true
        }])
      }, [_renderSlot(_ctx.$slots, "default")], 2);
    };
  }
});